import { SessionRepository } from '../../../repositories/sessionRepository';

type RegisterActivateRouteParams = {
	userId: string;
	activationToken: string;
};

export const registerActivateLoader = async ({ params }: { params: RegisterActivateRouteParams }) => {
	try {
		const queryResult = await SessionRepository.confirmToken(params);
		return { data: queryResult, error: null, params, isLoading: false };
	} catch (error) {
		return { data: null, isLoading: false, error };
	}
};
